const E502 = () => (
  <div className="error-container error-502">
    <h1>502</h1>
    <p className="title">Bad Gateway</p>
    <p>The server received an invalid response from the upstream server.</p>
  </div>
);

export default E502;